import * as React from 'react';

import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { ToneCardCSSStyle, ToneCardCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ToneRowOptionsPrivilage } from '../../../toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ToneEvenCardCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/toneevencardcssstyle';
import { FeaturedToneRowOptionsImpl } from '../featuredcategory/viewmodel/featuredcategorylistviewmodel';
import { ToneCardComponent } from '../featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { SearchListToneCardPlayerCSSStyleImpl } from './searchlisttonecardplayercss';
import { GridPaginationListViewModelImpl } from '../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';
import { ToneCardPlayerCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/tonecardplayercss';
import { ToneMobileCardPlayerCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/tonemobilecardplayercss';

export class SearchListToneViewModelImpl extends GridPaginationListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private audioPlayerWithProgress: AudioPlayerWithProgress;
    private toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
    private playerCSSStyle: SearchListToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle : ToneCardPlayerCSSStyleImpl;
  
    constructor(offset: string, context: BaseContext, private marginTop: string, title: string)
    {
        super(offset, context);
        this.onToneSelected = this.onToneSelected.bind(this);
        this.toneOddCardCSSStyle = new ToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ToneEvenCardCSSStyleImpl(context);
        this.toneRowOptionsPrivilage = new FeaturedToneRowOptionsImpl();
        this.playerCSSStyle = new SearchListToneCardPlayerCSSStyleImpl(context);
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    // setTitle(title: string)
    // {
    //     this.title = title;
    // }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    protected onToneSelected(): void
    {
       
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/searchlistviewmodel.tsx